<div *ngIf="demo" class="demo-banner">
    <img src="assets/media/application/demo-icon.svg"/><span class="ml-2">{{ 'okaju.general.demo' | translate }}</span>
</div>
<div style="height: 100%" [class.demo-environment]="demo">
    <router-outlet></router-outlet>

    <app-snackbar-container style="z-index: 9999999;pointer-events: none;"></app-snackbar-container>

    <app-toast-message-container style="z-index: 9999999;"></app-toast-message-container>
</div>
